var render = function render(){var _vm=this,_c=_vm._self._c;return _c('purpur-icon',{staticClass:"icon-vue",attrs:{"size":_vm.size,"svg":_vm.svg}})
}
var staticRenderFns = []

export { render, staticRenderFns }